module.exports = __webpack_public_path__ + "img/kocht_ellwangen.756c207e.jpg";